import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DocmanFolderModel } from '../services/docman.model.folder';

@Component({
  selector: 'folder-delete-modal',
  template: require('./folder.delete.modal.html')
})
export class FolderDeleteModalComponent implements OnInit {
  @Input() folder: any;

  @Output() onDelete = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  constructor(private docmanFolderModel: DocmanFolderModel) {}

  ngOnInit(): void {
  }

  deleteFolder(): void {
    let success = false;

    this.docmanFolderModel.deleteFolder(this.folder).then(
      () => {
        this.onDelete.emit();
      },
      () => {
        this.onClose.emit();
      }
    );
  }
}
